<modal
    [id]="'account-info-verification-warning-modal'"
    [title]="'accountInfoVerificationModal.title'"
    [modalType]="'modal-info'"
    [modalSize]="'small'"
    [closable]="false"
    [visible]="isModalVisible()"
    (visibleChange)="closeModal()">
    <div body>
        @if (impersonatedUser) {
            <message
                [id]="'account-info-verification-impersonation-warning'"
                [icon]="'fa-solid fa-triangle-exclamation'">
                <p>
                    <span
                        [innerHTML]="
                            'accountInfoVerificationModal.impersonation.message'
                                | translate: { impersonatingAccount: impersonatedUser.email }
                        ">
                    </span>
                    <a (click)="stopImpersonation()">{{
                        'accountInfoVerificationModal.impersonation.stop' | translate
                    }}</a>
                </p>
            </message>
        }

        @if (isLaboratoryMissing()) {
            <div id="laboratory-missing-container">
                <div class="body">
                    <h3 class="title">{{ 'accountInfoVerificationModal.labMissing.subtitle' | translate }}</h3>
                    <p class="message">
                        {{ 'accountInfoVerificationModal.labMissing.message' | translate }}
                    </p>
                </div>

                <div class="action-buttons">
                    <a [href]="accountUrl" target="_blank">
                        <ui-button
                            [id]="'settings-button'"
                            [label]="'accountInfoVerificationModal.labMissing.settingsBtn'">
                        </ui-button>
                    </a>
                </div>
            </div>
        }

        @if (isLaboratoryMissing() && isDefaultAddressMissing()) {
            <p-divider></p-divider>
        }

        @if (isDefaultAddressMissing()) {
            <div id="default-address-container">
                <div class="body">
                    <h3 class="title">
                        {{ 'accountInfoVerificationModal.defaultAddressMissing.title' | translate }}
                    </h3>
                    <p class="message">
                        {{ 'accountInfoVerificationModal.defaultAddressMissing.subtitle' | translate }}
                    </p>

                    <p
                        [innerHTML]="
                            'accountInfoVerificationModal.defaultAddressMissing.message1'
                                | translate: { accountUrl: accountUrl }
                        "></p>
                </div>

                <div class="action-buttons">
                    <a [href]="accountUrl" target="_blank">
                        <ui-button
                            id="manage-addresses-button"
                            [label]="'accountInfoVerificationModal.defaultAddressMissing.manageBtn'">
                        </ui-button>
                    </a>
                </div>
            </div>
        }
    </div>

    <ng-container footer>
        <ui-button
            [id]="'sign-out'"
            [label]="'accountInfoVerificationModal.signOut'"
            [text]="true"
            (onClick)="signOut()"></ui-button>

        <ui-button
            [id]="'refresh'"
            [label]="'accountInfoVerificationModal.refresh'"
            [text]="true"
            (onClick)="refreshPage()"></ui-button>
    </ng-container>
</modal>
